module.exports = __webpack_public_path__ + "media/images/webinar-3-449b7b77ec0576ca77e968f238fb602f.png";